<template>
    <div id="adobe-dc-view" class="tw-rounded-lg tw-overflow-hidden"></div>
</template>

<script setup>
import { nextTick, watch } from 'vue';
import { usePDFViewer } from '@/js/composables/usePdfViewer.js';

// const route = inject('route');

const props = defineProps({
    url: String,
});

const { viewInlinePdf } = usePDFViewer({
    // route,
});

watch(
    () => props.url,
    async (url) => {
        await nextTick();
        if (!url) {
            return;
        }

        viewInlinePdf(url, name, {
            options: {
                embedMode: 'SIZED_CONTAINER',
            },
        });
    },
    { immediate: true }
);
</script>

<script>
export const name = 'PDF';
</script>
